import React from 'react';

import { ProgressChartConfig } from '../../CustomBlocks/quiz/quizTypes';
import { CalendarIcon } from '../../shared/Icons';
import { NumberStepper, SettingsGroup, SettingsRow, Switch } from '../slotBookingEditor/settingsUi';
import { TILE } from '../slotBookingEditor/SlotBookingEditor.styles';
import { TextSetting } from './quizEditorUi';

interface ProgressChartEditorProps {
  config: ProgressChartConfig;
  onChange: (patch: Partial<ProgressChartConfig>) => void;
}

const ProgressChartEditor: React.FC<ProgressChartEditorProps> = ({ config, onChange }) => (
  <>
    <SettingsGroup title="Text" footer={<>Use <code>{'{{field_name}}'}</code> to insert an answer.</>}>
      <TextSetting label="Title" value={config.title} onChange={(title) => onChange({ title })} />
      <TextSetting
        label="Subtitle"
        multiline
        value={config.subtitle}
        onChange={(subtitle) => onChange({ subtitle })}
      />
      <TextSetting
        label="Footnote"
        placeholder="e.g. Results may vary"
        value={config.footnote}
        onChange={(footnote) => onChange({ footnote })}
      />
    </SettingsGroup>

    <SettingsGroup title="Chart">
      <SettingsRow label="Start and goal labels" stacked>
        <div className="qe-inline">
          <input
            type="text"
            className="sb-text-input"
            value={config.startLabel}
            placeholder="Now"
            onChange={(e) => onChange({ startLabel: e.target.value })}
          />
          <input
            type="text"
            className="sb-text-input"
            value={config.goalLabel}
            placeholder="Goal"
            onChange={(e) => onChange({ goalLabel: e.target.value })}
          />
        </div>
      </SettingsRow>
      <SettingsRow
        icon={<CalendarIcon size={16} />}
        iconColor={TILE.green}
        label="Goal reached in"
        description="Counted from the day the visitor sees it"
      >
        <NumberStepper
          value={config.weeks}
          min={1}
          max={52}
          step={1}
          unit="wk"
          label="Weeks to goal"
          onChange={(weeks) => onChange({ weeks })}
        />
      </SettingsRow>
      <SettingsRow label="Show goal date" description="Large date under the subtitle">
        <Switch
          checked={config.showGoalDate}
          label="Show goal date"
          onChange={(showGoalDate) => onChange({ showGoalDate })}
        />
      </SettingsRow>
    </SettingsGroup>
  </>
);

export default ProgressChartEditor;
